module.exports = "<div class=\"col-xs-12 main\" style=\"text-align: center\">\n    <img *ngIf=\"!paymentFailed\" style=\"width: 5em;\" src=\"" + require("../../../../../img/loading.gif") + "\" />\n    <label style=\"color: red\" *ngIf=\"paymentFailed\">Payment failed</label>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/super_user/start/transaction_return/transaction-return.component.html
 ** module id = 282
 ** module chunks = 0
 **/